import { Component } from 'react';
import { connect } from 'react-redux';

import * as List from 'selectors/lists';

import {
  modifyFile,
  modifyAsset,
  modifyCustomField, //Groups
  uploadAssetsFile,
  addAssetsFiles,
  removeAssetsFile,
  setAssetsIsSaving,
  removeAssetsUploadedFile,
} from 'containers/assets/actions';

import { getVisibleUploadFiles, getAssetsIsSaving, getAsset } from 'selectors/assets';
import { getCompany, getSubcompany } from 'auth/selectors';
import { valueFromEvent } from 'lib/util';

import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

import { addGrowlMessage as addMsg, clearGrowlMessages as clrMsg } from 'messages/actions';

class AssetsFormHandlers extends Component {
  constructor() {
    super();
    this.catalogNames = [];
    this.state = { isSubmitted: false, isValid: false };
  }

  componentWillReceiveProps(nextProps) {
    this.catalogNames = Object.keys(nextProps.catalogs);
  }

  componentWillMount() {
    //Groups
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'activos', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  }

  handleValidation = (isValid) => this.setState({ isValid });

  handleValueChange = (e) => {
    const modification = valueFromEvent(e);
    let [key] = Object.keys(modification);
    let val = modification[key];

    if (this.catalogNames.includes(key)) {
      val = this.props.elementsById[val];
      key = `_${key}`;
    } else if (key === 'employee') {
      val = this.props.employeesById[val];
      key = `_${key}`;
    } else if (key === 'costCenter') {
      val = this.props.costCentersById[val];
      key = `_${key}`;
    } else if (key === 'provider') {
      val = this.props.providersById[val];
      key = `_${key}`;
    } else if (key === 'asset_level') {
      console.log('%c ' + this.props.asset_levels, 'background: #222; color: #bada55');

      val = this.props.asset_levels[val];
      key = `_${key}`;
    } else if (key === 'account' || key === 'subaccount') {
      val = this.props.accountsById[val] || null;

      if (key === 'account') {
        this.props.modifyAsset({ _subaccount: null });
      }

      let _financialDepreciation = null;
      let _fiscalDepreciation = null;
      if (val) {
        _fiscalDepreciation = this.props.depreciations[val._fiscalDepreciation] || null;
        _financialDepreciation = this.props.depreciations[val._financialDepreciation] || null;
      }

      this.props.modifyAsset({ _financialDepreciation, _fiscalDepreciation });

      key = `_${key}`;
    } else if (key === 'financialDepreciation' || key === 'fiscalDepreciation') {
      val = this.props.depreciations[val];
      key = `_${key}`;
    } else if (key === 'project') {
      val = this.props.projectsById[val];
      key = `_${key}`;
    } else if (
      key === 'exchange' ||
      key === 'price' ||
      key === 'dollarAssetPrice' ||
      key === 'projectPrice' ||
      key === 'insurancePercent'
    ) {
      val = parseFloat(val) || '';
    }

    this.props.modifyAsset({ [key]: val });
  };

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modifyAsset({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  beforeSubmit =
    (callback) =>
    ({ isValid }) => {
      const { clrMsg, addMsg } = this.props;
      console.log('test');
      console.log('callback: ', callback);
      console.log('isValid: ', isValid);

      this.setState({ isSubmitted: true }, () => {
        clrMsg();

        if (!isValid) return addMsg('error.verify', 'danger', 'common.error');
        else {
          callback();
        }
      });
    };

  checkLimits = (e) => {
    let { addMsg, asset, company } = this.props;
    const { filesPerAsset, sizePerFile } = company;
    const { _files } = asset; // Existing files
    const { files } = this.props; // Files to upload.

    console.log('%c ' + _files.length, 'background: #222; color: #bada55');

    console.log('%c ' + 'Agregara', 'background: #222; color: #bada55');
    if (_files.length + files.length > filesPerAsset) {
      // console.log("Excedio el limite");
      console.log('%c ' + 'No puede agregar', 'background: #222; color: #bada55');
      addMsg('error.asset.files_limit_exceded', 'error', 'common.error');
      return false;
    } else {
      console.log('%c ' + 'Puede agregar', 'background: #222; color: #bada55');
      return true;
    }
  };

  uploadFiles = (callback) => (e) => {
    e && e.preventDefault();

    if (this.checkLimits(e)) {
      // Limits passed
      if (this.props.files.length) {
        this.props.setAssetsIsSaving(true);

        const uploads = this.props.files.map((file) =>
          this.props.uploadAssetsFile(
            file.id,
            file.file,
            this.props.company.id,
            this.props.subcompany.id
          )
        );

        Promise.all(uploads).then(() => {
          this.props.setAssetsIsSaving(false);
          callback();
        });
      } else {
        callback();
      }
    } else {
      // Fail Limits
      // fallaron los filtros de archivos
    }
  };

  render = () =>
    this.props.render({
      beforeSubmit: this.beforeSubmit,
      uploadFiles: this.uploadFiles,
      files: this.props.files,
      handleFileAdd: this.props.addAssetsFiles,
      handleFileChange: this.props.modifyFile,
      handleFileRemove: this.props.removeAssetsFile,
      handleFileUploadedRemove: this.props.removeAssetsUploadedFile,
      handleValidation: this.handleValidation,
      handleValueChange: this.handleValueChange,
      isSubmitted: this.state.isSubmitted,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      isValid: this.state.isValid,
      isSaving: this.props.isSaving,
    });
}

const mapStateToProps = (state) => ({
  catalogs: List.getCatalogsAndVisibleElements(state),
  asset_levels: List.getAsset_level(state),
  elementsById: List.getVisibleElements(state),
  employeesById: List.getEmployees(state),
  costCentersById: List.getCostCenters(state),
  providersById: List.getProviders(state),
  accountsById: List.getAccounts(state),
  depreciations: List.getDepreciations(state),
  projectsById: List.getProjects(state),
  files: getVisibleUploadFiles(state),
  asset: getAsset(state),
  isSaving: getAssetsIsSaving(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  modifyAsset,
  addMsg,
  clrMsg,
  addAssetsFiles,
  removeAssetsFile,
  uploadAssetsFile,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  setAssetsIsSaving,
  removeAssetsUploadedFile,
  modifyFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetsFormHandlers);



// WEBPACK FOOTER //
// src/containers/assets/AssetsFormHandlers.js